import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import Lottie from 'lottie-react';

import { GET_INDIVIDUAL_INFO } from 'apollo/queries';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { usePremiumEntitlement } from 'utils/hooks/usePremiumEntitlement';
import { useGetParams } from 'components/evieOnboarding/utils/useGetParams';
import { KEYS, USER_ROLES } from 'components/evieOnboarding/utils/constants';
import { ROUTES } from 'utils/constants';
import { useTabSettings } from 'utils/hooks/useTabSettings';
import { useFcPixel } from 'utils/hooks/useFcPixel';
import heartLoader from 'assets/heart-loader.json';

import Layout from 'components/evieOnboarding/Layout';
import BottomNav from 'components/evieApp/BottomNav';
import ThankyouScreen from 'components/evieOnboarding/ThankyouScreen';

const EvieDownload = () => {
  useTabSettings('Evie', '/evie-favicon.ico');

  const { push } = useGetParams();

  const [userToken] = useLocalStorage(KEYS.USER_TOKEN);
  const { loading: individualLoading, data: { getIndividualInfo = {} } = {} } = useQuery(GET_INDIVIDUAL_INFO, {
    skip: !userToken,
    context: {
      headers: {
        authorization: userToken ? `Bearer ${userToken}` : '',
        role: USER_ROLES.INDIVIDUAL,
      },
    },
  });
  const { id: individualId = null, oldProgramPayment = false } = getIndividualInfo;
  const { isPremium, isPending } = usePremiumEntitlement({ appUserId: individualId, oldProgramPayment });
  const isChecking = individualLoading || isPending;

  useFcPixel();

  useEffect(() => {
    if (!userToken || (!isChecking && !isPremium)) {
      push(ROUTES.EVIE_ONBOARDING);
    }
  }, [userToken, isChecking, isPremium]);

  return (
    <Layout>
      <BottomNav />
      {isPremium ? (
        <ThankyouScreen background="postpartum" />
      ) : (
        <div className="onboarding-layout__lottie">
          <Lottie animationData={heartLoader} loop style={{ width: 140, height: 110 }} />
        </div>
      )}
    </Layout>
  );
};

export default EvieDownload;
